import api from "@/api";

const state = () => ({
  data: null,
});

const actions = {
  async add({ commit, dispatch }, upc) {
    const data = await api({
      data: { upc },
      method: "POST",
      url: "/123/wishlist",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("ADD", data.info);
  },
  async delete({ commit, dispatch }, upc) {
    const data = await api({
      method: "DELETE",
      url: `/123/wishlist/${upc}`,
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("DELETE", data.info);
  },
  async fetch({ commit, dispatch }) {
    const data = await api({
      url: "/123/wishlist",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("UPDATE", data.info);
  },
};

const getters = {
  upcs(state) {
    return state.data && state.data.map((favorites) => favorites.upc);
  },
};

const mutations = {
  ADD(state, favorite) {
    state.data = [...state.data, favorite];
  },
  CLEAR(state) {
    state.data = [];
  },
  DELETE(state, unfavorite) {
    state.data = state.data.filter(
      (favorite) => favorite.upc !== unfavorite.upc
    );
  },
  INIT(state) {
    state.data = [];
  },
  UPDATE(state, favorites) {
    state.data = favorites;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
